import React from "react";
import styles from "./Table.module.sass";
import Checkbox from "../../../../components/Checkbox";
import Row from "./Row";

const Table = ({ items, selectedAttendances = [], onSelectAttendance, onSelectAll, onEdit, onDelete, onSendSignatureInvitation, session }) => {
  // Calculer si tous les éléments sont sélectionnés
  const allSelected = items.length > 0 && items.every(item => selectedAttendances.includes(item.id));

  const handleSelectAll = () => {
    if (onSelectAll) {
      onSelectAll(!allSelected);
    }
  };

  const handleSelectAttendance = (id, isSelected) => {
    if (onSelectAttendance) {
      onSelectAttendance(id, isSelected);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={allSelected}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Étudiant</div>
          <div className={styles.col}>Email</div>
          <div className={styles.col}>Présence</div>
          <div className={styles.col}>Actions</div>
        </div>
        {items.map((x, index) => (
          <Row
            item={x}
            key={index}
            index={index}
            value={selectedAttendances.includes(x.id)}
            onChange={(isChecked) => handleSelectAttendance(x.id, isChecked)}
            onEdit={onEdit}
            onDelete={onDelete}
            onSendSignatureInvitation={onSendSignatureInvitation}
            onAttendanceUpdate={(attendanceId) => {
              // Dispatch un événement pour notifier que l'attendance a été mise à jour
              const event = new CustomEvent('attendanceUpdated', { detail: { attendanceId } });
              window.dispatchEvent(event);
            }}
            session={session}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
